import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../pageheader/PageHeader";
import CheckboxV2 from "../material/checkboxV2/CheckBoxV2";
import moment from "moment/moment";
import { HashLoader } from "react-spinners";
import "moment/locale/th";
import * as boardApi from "../../service/boardApi";
import NotfoundUi from "../notfound/NotfoundUi";
import icon__user__bg__black from "../../asset/icon/user-bg-black.svg";
import icon__user__bg__orange from "../../asset/icon/user-bg-orange.svg";

import { CurrentUserContext } from "../../App";

function AnsUser({ roleUser }) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [hideName, setHideName] = useState(true);
  const [backpath, setBackpath] = useState("");

  const [valueTextArea, setValueTextArea] = useState("");

  const [board_data, setBoard_data] = useState("");
  const [board_comment_list, setBoard_comment_list] = useState([]);

  useEffect(() => {
    // console.log(location.state?.item);
    if (roleUser === "Laboratory") {
      if (!location.state?.item) {
        navigate("/laboratory/ans");
      }
      setBackpath("/laboratory/ans");
    } else if (roleUser === "Medical") {
      if (!location.state?.item) {
        navigate("/doctor/ans");
      }
      setBackpath("/doctor/ans");
    } else if (roleUser === "Patient") {
      if (!location.state?.item) {
        navigate("/patient/ans");
      }
      setBackpath("/patient/ans");
    } else if (roleUser === "Admin") {
      if (!location.state?.item) {
        navigate("/admin/ans");
      }
      setBackpath("/admin/ans");
    } else if (roleUser === "Executive") {
      if (!location.state?.item) {
        navigate("/manager/ans");
      }
      setBackpath("/manager/ans");
    }
  }, [backpath]);

  useEffect(() => {
    // console.log();
    if (!location.state?.item) {
      navigate(backpath);
    } else {
      ViewgetBoardData(location.state.item.board_id);
    }
  }, []);

  // console.log(backpath);

  const ViewgetBoardData = async (border_id) => {
    setLoading(true);
    let res = await boardApi.ViewgetBoardData(border_id);
    // console.log("api getBoardData ", res["data"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]);
        setBoard_data(res["data"]["board_data"]);
        setBoard_comment_list(res["data"]["board_data"]["board_comment_list"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const ManagesaveComment = async (
    border_id,
    comment_detail,
    show_name,
    attachment_list,
  ) => {
    setLoading(true);
    let res = await boardApi.ManagesaveComment(
      border_id,
      comment_detail,
      show_name,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        setValueTextArea("");
        ViewgetBoardData(location.state.item.board_id);
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onClickBtnComment = () => {
    if (valueTextArea === "") {
      setIsMessage({
        type: "warning",
        data: "กรุณาใส่แสดงความคิดเห็นก่อนกดบันทึก",
      });
    } else {
      ManagesaveComment(location.state.item.board_id, valueTextArea, hideName);
    }
  };

  function urlify(text) {
    let urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(urlRegex, function (url) {
      let hyperlink = url;
      if (!hyperlink.match("^https?:\/\/")) {
        hyperlink = "http://" + hyperlink;
      }
      return (
        '<a className="blue" href="' +
        url +
        '" rel="noopener" noreferrer>' +
        url +
        "</a>"
      );
    });
  }

  return (
    <>
      <PageHeader btnBackWard backpath={backpath} />
      <div className="mx-64 xl:mx-16 lg:mx-14 sm:mx-10 mb-16 sm:mt-4">
        <div className="bg-[#dff2e8] border-2 border-[#FFFFFF] rounded-xl p-[20px] sm:p-[10px]">
          {!loading ? (
            <>
              {/* คนโพส */}
              <div className="grid items-center grid-cols-[50px_auto]">
                <img
                  className="rounded-full h-[40px] w-[40px]"
                  src={icon__user__bg__black}
                  alt=""
                />
                <div className="sm:text-sm">
                  <div className="font-bold">
                    {board_data["author"]?.["fname"] +
                      " " +
                      board_data["author"]?.["lname"]}
                  </div>
                  <div className="text-[#000000]">
                    {" "}
                    เมื่อ{" "}
                    {board_data["create_date"]?.["time"] +
                      " " +
                      moment(board_data["create_date"]?.["timestamp"])
                        .add(543, "years")
                        .format("Do MMM YY")}
                  </div>
                </div>
              </div>
              <div className="">
                <div className="text-[#2E2E2E] text-[20px] sm:text-[16px] font-bold my-[15px] break-words">
                  {board_data["board_title"]}
                </div>
                <div className="text-[#2E2E2E] sm:text-[14px] my-[15px] indent-[20px] break-words">
                  {board_data["board_detail"]}
                </div>
              </div>
            </>
          ) : (
            <HashLoader
              loading={loading}
              style={{ display: "flex", justifyContent: "center" }}
              color="#FF9768"
            />
          )}
        </div>

        {/* คนเม้น */}
        {board_comment_list.length > 0 ? (
          <>
            {board_comment_list.map((i, idx) => {
              // console.log(i);
              return (
                <div className="bg-[#fff9e4] border-2 border-[#FFFFFF] rounded-xl p-[20px] sm:p-[10px] mt-[20px]">
                  {/* <div className='border-[1px] border-solid border-[#339A80] w-full bg-[#339A80] my-[15px]'></div> */}
                  <div className="grid items-center grid-cols-[50px_auto]">
                    <img
                      className="rounded-full h-[40px] w-[40px]"
                      src={icon__user__bg__orange}
                      alt=""
                    />
                    <div className="sm:text-sm">
                      <div className="font-bold text-[#339A80]">
                        {i["author"]?.["fname"] + " " + i["author"]?.["lname"]}
                      </div>
                      <div className="text-[#000000]">
                        เมื่อ{" "}
                        {i["create_date"]?.["time"] +
                          " " +
                          moment(i["create_date"]?.["timestamp"])
                            .add(543, "years")
                            .format("Do MMM YY")}
                      </div>
                    </div>
                  </div>
                  <div className="text-[#339A80] sm:text-[16px] indent-[20px] font-medium my-[15px] break-words">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: urlify(i["comment_detail"]),
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </>
        ) : null}

        <div className="py-10 sm:py-3"></div>

        <div className="bg-white h-[150px] w-full border-2 border-[#A2B5BC] rounded-xl">
          <div className="grid h-full grid-cols-[auto_150px] sm:grid-cols-1">
            <textarea
              value={valueTextArea}
              onChange={(e) => {
                setValueTextArea(e.target.value);
              }}
              className="w-full h-32 sm:h-24 overflow-hidden outline-none text=state-100 text-[#000000] p-5 focus:outline-none mt-1 text-[18px]"
              placeholder="แสดงความคิดเห็น"
            ></textarea>
            <div className="grid justify-center items-center">
              <button
                onClick={() => {
                  onClickBtnComment();
                }}
                className="button-theme-pg flex justify-center items-center w-32 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan "
              >
                SUBMIT
              </button>
              {/* <button className='button-theme-pg flex justify-center items-center w-32 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan '>วิดีโอ</button> */}
            </div>
          </div>
        </div>

        <div className="flex justify-end items-center gap-[10px] my-[5px]">
          <div>
            <CheckboxV2 id="1" value={hideName} setValue={setHideName} />
          </div>
          <div>แสดงชื่อผู้ใช้งานของฉัน</div>
        </div>
      </div>
    </>
  );
}

export default AnsUser;
